(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magazine-article"]) return;
  try {
    
  $('.fade').on('inview', function(event, isInView) {
    if (isInView) {
      $(this).addClass('active');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
